import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  formControlLabel: {
    margin: 15,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
});

const RadioSelector = props => {
  const { classes, options, title, handleChange, selectedOption } = props;

  return options.length ? (
    <div className={classes.root}>
      <FormControl
        component="fieldset"
        required
        className={classes.formControl}
      >
        <FormLabel component="legend">{title}</FormLabel>
        <RadioGroup
          aria-label={title}
          name={title}
          className={classes.group}
          value={selectedOption}
          onChange={handleChange}
        >
          {options.map((opt, i) => {
            return (
              <FormControlLabel
                value={opt.value}
                control={<Radio />}
                label={opt.label}
                key={`${opt.value}${i}`}
                className={classes.formControlLabel}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  ) : null;
};

export default withStyles(styles)(RadioSelector);



// WEBPACK FOOTER //
// ./src/components/RadioSelector.js